// consts

export const MAX_SAFE_INTEGER_VARIABLE_VALUE = 18446744073709551616n;
